import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslationService } from '../../shared/translation.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';

const MKT_BANNER_VIEWED = 'mkt_banner_viewed';
const MKT_TRANSLATION_KEY = 'studyBundle.mktAnnouncement';

const ZOOM_BANNER_VIEWED_COOKIE_NAME = 'zoom_banner_viewed';

@Component({
  selector: 'lp2-live-class-carousel-banners',
  templateUrl: './live-class-carousel-banners.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveClassCarouselBannersComponent implements OnInit {
  zoomHasBeenPreviouslyViewed: boolean;
  mktHasBeenPreviouslyViewed: boolean;
  mktMessage: string;
  liveClassEnabled: boolean;

  constructor(private translationService: TranslationService, private oeAppPersonService: OeAppPersonService) {}

  ngOnInit() {
    this.liveClassEnabled = this.oeAppPersonService.liveClassEnabled;
    this.zoomHasBeenPreviouslyViewed =
      localStorage.getItem(ZOOM_BANNER_VIEWED_COOKIE_NAME) === 'true';
    this.mktHasBeenPreviouslyViewed =
      sessionStorage.getItem(MKT_BANNER_VIEWED) === 'true';
    const translatedMessage = this.translationService.translate(
      MKT_TRANSLATION_KEY
    );
    if (
      translatedMessage &&
      translatedMessage.trim() &&
      translatedMessage !== MKT_TRANSLATION_KEY
    ) {
      this.mktMessage = translatedMessage;
    }
  }

  closeMktBanner() {
    this.mktHasBeenPreviouslyViewed = true;
    sessionStorage.setItem(MKT_BANNER_VIEWED, 'true');
  }

  closeZoomBanner() {
    this.zoomHasBeenPreviouslyViewed = true;
    localStorage.setItem(ZOOM_BANNER_VIEWED_COOKIE_NAME, 'true');
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-carousel-banners/live-class-carousel-banners.component.ts